export default __webpack_public_path__ + "static/media/2011.56c4adfb.png";